import {
  SET_TRAINER_DASHBOARD_CARD_DATA,
  SET_TRAINER_DASHBOARD_LIVE_DATA,
} from "../types/types";

export const setTrainerDashboardCardData = (value) => {
  return {
    type: SET_TRAINER_DASHBOARD_CARD_DATA,
    payload: { data: value },
  };
};
export const setTrainerLiveClassCardData = (value) => {
  return {
    type: SET_TRAINER_DASHBOARD_LIVE_DATA,
    payload: { data: value },
  };
};
